<template lang="pug">
.transactions_preview(v-if='open')
  .modal.is-active.animated.faster.fadeIn
    .modal-background(@click='close')
    .modal-card(style='width: 80%; max-width: 850px;')
      .modal-card-head(@click='close')
        p.modal-card-title {{ $t('Transactions') }}
        a.delete(@click='close')
      .modal-card-body
        .subtitle.is-5
          span {{ $t('Categories') }}:
          small  {{ categories.join(', ') || $t('No category') }}
        transactions_table(:transactions='transactions')
        .has-text-centered
          a.button.is-small(@click='display_more()' v-if='transactions.length > visible_transactions.length') {{ $t('show more') }}

</template>

<script>
export default {
  name: 'transactions_preview',
  components: {
    transactions_table: require('components/inside/elements/transactions_table.vue').default,
    transaction_amount: require('components/inside/pages/transactions/transaction_amount.vue').default
  },
  data() {
    return {
      limit: 100
    }
  },
  computed: {
    ids() {
      this.limit = 100
      return this.$store.state.ui.transactions.current.preview_ids
    },
    open() {
      return this.ids.length > 0
    },
    transactions() {
      return this.$store.state.user.transactions.filter((tr) => this.ids.includes(tr.id))
    },
    categories() {
      return _.uniq(_.map(this.transactions, (tr) => `"${tr.category || '...'}"`)).sort()
    },
    visible_transactions() {
      return _.take(this.transactions, this.limit)
    }
  },
  mounted() {
    this.event = `keyup.${this.$options.name}`;
    return $(window).off(this.event).on(this.event, e => {
      if (e.keyCode === 27) { this.close() }
      return false;
    });
  },
  methods: {
    close () {
      this.$store.dispatch('hideTransactionsPopovers')
      this.$store.commit('TRANSACTIONS/PREVIEW', [])
    },
    display_more(){
      this.limit += 100
    }
  }
}
</script>

<style lang="sass">
.transactions_preview
  .subtitle
    margin-bottom: 0.5rem
</style>
